/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TemplateUsage {
    Description = '0',
    Embedded = 1,
}
